import type { SocialAuthTypes } from '@patrianna/shared-patrianna-types/store/AuthModule'
import { appleAuth as appleAuthAction } from '@patrianna/shared-store/auth/store/appleActions'
import type { useSearchParams } from 'next/navigation'

import type { TypedThunk } from 'src/store/types'
import { socialSignInHandler, socialSignUpHandler } from 'store/modules/auth/actions'
import { LS_AUTH_TYPE, setDataToLocalStorage } from 'utils/localStorage'

export const appleAuth =
  (
    authType: SocialAuthTypes,
    isMobile: boolean,
    routerPush: (path: string, callback?: () => void) => void,
    routerQuery: ReturnType<typeof useSearchParams>,
    routerPath: string,
  ): TypedThunk =>
  async (dispatch) => {
    dispatch(setDataToLocalStorage(LS_AUTH_TYPE, authType, false))
    dispatch(
      appleAuthAction({
        authType,
        authSocialSignInHandler: socialSignInHandler,
        authSocialSignUpHandler: socialSignUpHandler,
        isMobile,
        routerPush,
        routerQuery,
        routerPath,
      }),
    )
  }
